import {Input, NgModule} from '@angular/core';
import { DashboardComponent } from './dashboard.component';
import { StatisticBoxComponent } from './statistic-box/statistic-box.component';
import { InformationBoxComponent } from './information-box/information-box.component';
import {InfraModule} from 'ac-infra';
import {HighchartModule} from '../utils/highchart/highchart.module';
import { ActiveAlarmsComponent } from './active-alarms/active-alarms.component';
import {CommonModule} from '@angular/common';
import {ChooseTopologyItemModule} from '../utils/choose-topology-item/choose-topology-item.module';
import {TopRoutesComponent} from './top-routes/top-routes.component';
import { InfoBoxComponent } from './info-box/info-box.component';
import { NzCarouselModule } from 'ng-zorro-antd/carousel';
import {MaterialModule} from '../material.module';

@NgModule({
  declarations: [
    DashboardComponent,
    StatisticBoxComponent,
    InformationBoxComponent,
    ActiveAlarmsComponent,
    TopRoutesComponent,
    InfoBoxComponent
  ],
  imports: [
    CommonModule,
    InfraModule,
    HighchartModule,
    ChooseTopologyItemModule,
    NzCarouselModule,
    MaterialModule
  ]
})
export class DashboardModule {
}
